module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAASAgMAAAASx9efAAAADFBMVEUAAAD///////////84wDuoAAAAA3RSTlMAf4C/aSLHAAAALUlEQVQI12MAAQ4g5gVifgcgvgDEX4D4LxD/dwDiC1DsABH7AlXjANHDwgAGANJpDPlEBXy5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/stats/arrow_right.png
// module id = 678
// module chunks = 3